import React from "react";
import { Box, Container, Grid, Typography, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../assets/nextix/nextix-logo-white-version.png";
import { blogPosts } from '../data/blogData';
import privacyPolicyPdf from '../DATA-PRIVACY-STATEMENT.pdf';

const FooterLink = ({ to, label, isExternal = false }) => (
    <Box sx={{ mb: 1 }}>
        {isExternal ? (
            <MuiLink href={to} target="_blank" rel="noopener noreferrer" sx={{ color: "#aaa", textDecoration: "none", fontSize: "14px", "&:hover": { color: "#fff" } }}>
                {label}
            </MuiLink>
        ) : (
            <Link to={to} style={{ color: "#aaa", textDecoration: "none" }}>
                <Typography component="span" sx={{ fontSize: "14px", "&:hover": { color: "#fff" } }}>
                    {label}
                </Typography>
            </Link>
        )}
    </Box>
);

const FooterSectionTitle = ({ title }) => (
    <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ color: "#fff", fontSize: "16px", fontWeight: "bold", mb: 0.5 }}>
            {title}
        </Typography>
        <Box sx={{ width: "20px", height: "1px", backgroundColor: "#fff" }} />
    </Box>
);

const FooterComponent = () => {
    return (
        <Box sx={{ backgroundColor: "#2d2d2d", py: 8, fontFamily: '"Lato", "Open Sans", sans-serif', color: "#fff" }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Logo & Copyright */}
                    <Grid item xs={12} md={3}>
                        <Box sx={{ mb: 2 }}>
                            <img src={logo} alt="Nextix Logo" style={{ height: "50px", objectFit: "contain" }} />
                        </Box>
                        <Typography sx={{ fontSize: "14px", color: "#ddd", mb: 4 }}>
                            Building Digital Innovations
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "#888" }}>
                            Copyright © {new Date().getFullYear()} All Rights Reserved
                        </Typography>
                    </Grid>

                    {/* Our Businesses */}
                    <Grid item xs={12} md={3} sx={{ textAlign: 'start' }}>
                        <FooterSectionTitle title="Our Businesses" />
                        <FooterLink to="/business-identity" label="Identity" />
                        <FooterLink to="/business-cloud" label="Cloud" />
                        <FooterLink to="/business-authentication" label="Authentication" />
                        <FooterLink to="/business-fintech" label="Fintech" />
                        <FooterLink to="/business-digital-infrastructure" label="Digital Infrastructure" />
                        <FooterLink to={privacyPolicyPdf} label="Privacy Policy" isExternal={true} />
                    </Grid>

                    {/* News and Updates */}
                    <Grid item xs={12} md={3} sx={{ textAlign: 'start' }}>
                        <FooterSectionTitle title="News and Updates" />
                        {blogPosts.slice(0, 2).map((post) => (
                            <Box key={post.id} sx={{ display: 'flex', mb: 2 }}>
                                {post.imageUrl && (
                                    <Box sx={{ width: 50, height: 50, mr: 2, bgcolor: "#555", flexShrink: 0 }}>
                                        <img src={post.imageUrl} alt={post.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.style.backgroundColor = '#555'; }} />
                                    </Box>
                                )}
                                <Box>
                                    <Link to={`/news-and-updates/${post.slug}`} style={{ textDecoration: 'none' }}>
                                        <Typography sx={{ color: "#aaa", fontSize: "13px", fontWeight: 'bold', display: 'block', lineHeight: 1.3, mb: 0.5, "&:hover": { textDecoration: 'none', color: '#fff' } }}>
                                            {post.title}
                                        </Typography>
                                    </Link>
                                    <Typography sx={{ fontSize: "12px", color: "#aaa" }}>
                                        {post.date}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Grid>

                    {/* Contact Us */}
                    <Grid item xs={12} md={3} sx={{ textAlign: 'start' }}>
                        <FooterSectionTitle title="Contact Us" />
                        <Box sx={{ mb: 2 }}>
                            <Typography sx={{ fontSize: "14px", color: "#aaa", mb: 0.5 }}>
                                Email Us:
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Inquiry: <MuiLink href="mailto:info@nextix.co" sx={{ color: "#aaa", textDecoration: "none", "&:hover": { color: "#fff" } }}>info@nextix.co</MuiLink>
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Support: <MuiLink href="mailto:support@nextix.co" sx={{ color: "#aaa", textDecoration: "none", "&:hover": { color: "#fff" } }}>support@nextix.co</MuiLink>
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Privacy: <MuiLink href={privacyPolicyPdf} target="_blank" rel="noopener noreferrer" sx={{ color: "#aaa", textDecoration: "none", "&:hover": { color: "#fff" } }}>dpo@nextix.co</MuiLink>
                            </Typography>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Manila, Philippines
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Phone: (63) 2 8828-1011
                            </Typography>
                        </Box>

                        <Box>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Cebu, Philippines
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#aaa" }}>
                                Phone: (63) 32 384-9309
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container >
        </Box >
    );
};

export default FooterComponent;
